import { render, staticRenderFns } from "./Allocations.vue?vue&type=template&id=a98cd544&scoped=true&"
import script from "./Allocations.vue?vue&type=script&lang=js&"
export * from "./Allocations.vue?vue&type=script&lang=js&"
import style0 from "./Allocations.vue?vue&type=style&index=0&id=a98cd544&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98cd544",
  null
  
)

export default component.exports